// Sanitiza folios/placas leídos por pistola USB o tecleados manualmente.
// Los lectores USB con distribución de teclado distinta suelen emitir comillas
// simples ' o acentos ´ ` en lugar del guion medio -. Esta función los normaliza,
// elimina espacios en blanco y pasa a mayúsculas.
// Ej: "T'260808'5619" -> "T-260808-5619" · "ptc´060826´001" -> "PTC-060826-001".
// Además tolera el escaneo de la URL COMPLETA del QR (incluso mal traducida por el
// teclado, p.ej. "HTTPSÑ--APP.PARKNOVA.MX-E-T-260814-8397"): extrae el folio embebido.
//
// PURO (Fase 0 · dominio compartido Web/Native): solo manipula strings; sin navegador, UI, React, API ni storage.
// Movido desde lib/utils.js (que ahora re-exporta desde aquí). Comportamiento idéntico.
export function sanitizeFolio(str) {
  if (str == null) return "";
  let s = String(str).trim().replace(/[´`'‘’‚‹›]/g, "-");
  // Si se escanea el QR del boleto (una URL a la landing /e/:folio o /t/:folio),
  // extrae el último segmento de la ruta para resolver el folio.
  const m = s.match(/\/(?:e|t)\/([^/?#\s]+)/i);
  if (m) s = decodeURIComponent(m[1]);
  s = s.replace(/\s+/g, "").toUpperCase();
  // Escaneo de URL completa o texto con "ruido": el folio siempre tiene la forma
  // PREFIJO-DDMMAA-SECUENCIAL. Lo extraemos aunque venga rodeado de otros caracteres.
  const folio = s.match(/([A-Z0-9]{1,4})-(\d{6})-(\d{1,6})/);
  if (folio) return `${folio[1]}-${folio[2]}-${folio[3]}`;
  return s;
}
